import PhotoPlaceholder from "./PhotoPlaceholder.jsx";
import { useApp } from "../app/AppContext.jsx";
import { useEffect, useState } from "react";

export default function Gallery({ images = [], alt }) {
  const { t } = useApp();
  const [failed, setFailed] = useState(new Set());
  const [i, setI] = useState(0);
  useEffect(() => { setI(0); }, [images]);

  if (!images.length) {
    return <div className="gallery__main card__media--empty" style={{ display: "grid", placeItems: "center" }}><PhotoPlaceholder /></div>;
  }

  const go = (d) => setI((c) => (c + d + images.length) % images.length);

  return (
    <div>
      <div className="gallery__main">
        {failed.has(images[i]) ? <PhotoPlaceholder /> : <img src={images[i]} alt={`${alt} — ${i + 1}/${images.length}`} onError={() => setFailed((s) => new Set([...s, images[i]]))} />}
        {images.length > 1 && (
          <div className="gallery__nav">
            <button className="gallery__arrow" onClick={() => go(-1)} aria-label={t("common.previous")}>‹</button>
            <button className="gallery__arrow" onClick={() => go(1)} aria-label={t("common.next")}>›</button>
          </div>
        )}
        <span className="card__count">{i + 1} / {images.length}</span>
      </div>

      {images.length > 1 && (
        <div className="gallery__thumbs">
          {images.slice(0, 24).map((src, n) => (
            <button key={`${src}-${n}`} className={`gallery__thumb${n === i ? " is-active" : ""}`} onClick={() => setI(n)} aria-label={t("common.photo", { n: n + 1 })} aria-pressed={n === i}>
              <img src={src} alt="" loading="lazy" decoding="async" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
